module.exports = __webpack_public_path__ + "static/img/Door_French.12989ac.jpg";